export const parallax = elements => {
    if ('undefined' !== elements && elements.length > 0) {
        elements.forEach( element => {
            let y = window.innerHeight - element.getBoundingClientRect().top
            if (y > 0) {
                element.style.transform = 'translate3d(0, -' + (0.1 * y) + 'px ,0)'
            }
        })
    }
}
